import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  adGroups: [],
  form: {
    pcWeight: 100,
    mobileWeight: 100,
    keywordExtensionWeight: 100,
  },
  preview: {
    pcWeight: 100,
    mobileWeight: 100,
    keywordExtensionWeight: 100,
  },
}

export const showAdGroupsWeightEdit = createAxiosThunk(
  'dashboard/showAdGroupsWeightEdit',
  adGroupIds => api.ad.getAdGroups(adGroupIds)
)

export const updateAdGroupsWeight = createAxiosThunk(
  'dashboard/updateAdGroupsWeight',
  ({ pcWeight, mobileWeight, keywordExtensionWeight }, { getState }) => {
    const { adGroups } = getState().dashboard.operation.adGroupWeightEdit
    return api.ad.patchAdGroupsBiddingStrategy({
      adGroupIds: adGroups.map(({ id }) => id),
      changePcWeight: 'Y',
      pcWeight,
      changeMobileWeight: 'Y',
      mobileWeight,
      changeKeywordExtensionWeight: 'Y',
      keywordExtensionWeight,
      changeMaxBiddingAmount: 'N',
      changeContentMatchingMaxBiddingAmount: 'N',
    })
  }
)

const adGroupWeightEditSlice = createSlice({
  name: 'dashboard/adGroupWeightEdit',
  initialState,

  reducers: {
    hideAdGroupWeightEdit: () => initialState,
    setPcWeight: (state, { payload }) => {
      state.form.pcWeight = payload
    },
    setMobileWeight: (state, { payload }) => {
      state.form.mobileWeight = payload
    },
    setKeywordExtensionWeight: (state, { payload }) => {
      state.form.keywordExtensionWeight = payload
    },
    showPreview: (
      state,
      { payload: { pcWeight, mobileWeight, keywordExtensionWeight } }
    ) => {
      state.preview = { ...state.form }
      state.preview.pcWeight = pcWeight
      state.preview.mobileWeight = mobileWeight
      state.preview.keywordExtensionWeight = keywordExtensionWeight
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(showAdGroupsWeightEdit.pending, state => {
      state.isLoading = true
      state.visible = true
    })

    builder.addCase(showAdGroupsWeightEdit.rejected, (state, { payload }) => {
      state.loadingError = payload
      state.isLoading = false
    })

    builder.addCase(
      showAdGroupsWeightEdit.fulfilled,
      (state, { payload: { adGroupDtos } }) => {
        const adGroups = adGroupDtos.map(({ id, name, biddingStrategy }) => ({
          id,
          name,
          biddingStrategy,
        }))
        state.adGroups = adGroups
        const hasSameValue =
          adGroups.length > 1 &&
          adGroups.every((value, index, array) => {
            const current = value.biddingStrategy
            const other = array[0].biddingStrategy
            return (
              current.pcWeight === other.pcWeight &&
              current.mobileWeight === other.mobileWeight &&
              current.keywordExtensionWeight === other.keywordExtensionWeight
            )
          })
        if (adGroups.length === 1 || hasSameValue) {
          const [first] = adGroups
          const {
            biddingStrategy: { pcWeight, mobileWeight, keywordExtensionWeight },
          } = first
          state.form.pcWeight = pcWeight
          state.form.mobileWeight = mobileWeight
          state.form.keywordExtensionWeight = keywordExtensionWeight
        }
        state.isLoading = false
      }
    )

    builder.addCase(updateAdGroupsWeight.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateAdGroupsWeight.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateAdGroupsWeight.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const { hideAdGroupWeightEdit, showPreview, hidePreview } =
  adGroupWeightEditSlice.actions
export default adGroupWeightEditSlice.reducer
